import { makeStyles } from '@mui/styles';

export const useMenuStyles = makeStyles(() => ({
  leftMenu: {
    display: 'inline-block',
    marginLeft: 8,
    overflowY: 'auto',
    padding: 0,
    width: 'calc(100% - 8px)',
  },
  headerMenu: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    padding: 0,
  },
  headerMenuStretched: {
    justifyContent: 'space-between',
  },
  subHeader: {
    fontSize: '12px',
    lineHeight: '16px',
    alignItems: 'center',
    letterSpacing: '0.4px',
    opacity: '0.54',
    paddingTop: '12px',
  },
}));
